export default "__VITE_ASSET__cTDz$bHA__"